<div class="row">
    <div class="col-md-11">
        <button style="float:right" class="btn btn-narrow btn-info" 
        (click)="openFleetOverview()">Fleet Safety Summary</button>
    </div>
</div>
<div class="row">
    <div class="col-md-11">
    <div class="table-responsive dashtable">
        <table id = 'safetyEvent' mat-table [dataSource] = "safetyEventTblDataSource" #sortSafetyEvent ='matSort' matSort class="table table-condensed table-striped" multiTemplateDataRows>
            <ng-container matColumnDef="sortBase">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    VIN/Vehicle ID
                </th>
                <td mat-cell *matCellDef="let element">
                    {{element.vin && element.vin != 'N/A' ? (element.vin.replace(element.vin.slice(0, (element.vin.length) - 6), "") + '/') : ('/' + element.vehicleId)}}
                </td>
            </ng-container>
            
            <ng-container matColumnDef="vehicleType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300">
                    Vehicle Type
                </th>
                <td mat-cell *matCellDef="let element" > {{element.vehicleType}} </td>
            </ng-container>
            
            <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Year
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.year}}

                </td>
            </ng-container>
            <ng-container matColumnDef="make" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Make
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.make }}
                </td>
            </ng-container>

            <ng-container matColumnDef="model" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Model
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.model}}
                </td>
            </ng-container>

            <ng-container matColumnDef="totalEvents" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Total Events
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.totalEvents}}
                </td>
            </ng-container>

            <ng-container matColumnDef="totalEventPer1K" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Total Events Per 1K
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.totalEventPer1K | number: '1.001-3' }}
                </td>
            </ng-container>


            <ng-container matColumnDef="sum_TotalMiles" >
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="font-size: 1.1em; font-weight: 300;">
                    Total Mi.
                </th>
                <td mat-cell *matCellDef="let element"> 
                    {{ element.sum_TotalMiles | number: '1.01-1' }}
                </td>
            </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              
             <ng-container matColumnDef="expandedDetail"  >
                <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="safetyEventColumns.length"
                style="padding: 0px;"
                
                >
                <div
                    class="element-detail"
                    *ngIf="element.embededDetails?.data.length"
                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                >
                    <div *ngIf="expandedElement">
                    <table
                        #innerTables
                        mat-table
                        #innerSort="matSort"
                        [dataSource]="element.embededDetails"
                        matSort
                        class="table table-condensed table-striped innerTables"
                        
                    >
                        <ng-container matColumnDef="categoryType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Safety Event</th>
                        <td mat-cell *matCellDef="let element">{{element.categoryType}}</td>
                        </ng-container>

                        <ng-container matColumnDef="sum_TotalNumberOfEvents">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            Count
                        </th>
                        <td mat-cell *matCellDef="let element">{{element.sum_TotalNumberOfEvents}}</td>
                        </ng-container>

                        <ng-container matColumnDef="countPer1K">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Per 1K</th>
                        <td mat-cell *matCellDef="let element">{{element.sum_TotalNumberOfEvents / 1000 | number: '1.001-3' }}</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="safetyEventEmbedColumns"></tr>
                        <tr
                        mat-row
                        *matRowDef="let row; columns: safetyEventEmbedColumns;"
                        ></tr>
                    </table>
                    </div>
                </div>
                </td>
            </ng-container>
        

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->


          

            <tr mat-header-row *matHeaderRowDef="safetyEventColumns"></tr>
            <tr mat-row *matRowDef="let element; let index = dataIndex; columns: safetyEventColumns;"  style="height: 0px;"
            class="element-row"

            [ngClass] = "{alternateRow: index % 2 !== 0 }"
            

            (click) = "toggleRow(element)"
            [class.element-row]="element.embededDetails?.data.length"
            [class.expanded-row]="expandedElement === element"></tr>

            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" 
            class="detail-row" 
            ></tr>
          


        </table>
        <mat-paginator #paginatorSafetyEvent [pageSizeOptions]="[10, 25, 100]" showFirstLastButtons style="margin-bottom: 4%;margin-top:-1%; background: none; color: whitesmoke;"></mat-paginator>
        
    </div>
</div>
</div>